<template>
    <header class="header">
        <div class="header__item header__logo">
            LoGo
        </div>
        <div class="header__item-group"></div>
    </header>
</template>

<script>
  export default {
    name: "Header"
  };
</script>

<style lang="scss" scoped>
  .header {
    height: $header-height;
  }
</style>
